<elder-single-pane-wrapper>
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [idField]="'id'"
    (itemClick)="openSideDetail($event)"
  >
    <elder-data-toolbar
      *elderTableToolbar
      (requestNew)="create()"
      [canRemove]="false"
      [canAdd]="true"
      [canMore]="false"
    >
      <ng-template elderToolbarContent="center">
        <elder-search-box
          dense
          class="flex-60 pt-xs"
          queryKey="query"
          [autoPanel]="false"
          [elderSearchContext]="data.filter"
          [forcedFilters]="forcedFilters$ | async"
        >
          <!-- Advanced search -->
          <elder-search-panel class="layout-col p-sm">
            <div class="layout-row place-start-center gap-sm">
              <mat-form-field>
                <input
                  matInput
                  name="ownedBy"
                  ngModel
                  placeholder="{{ 'orders.ownedBy' | translate }}"
                  elderSearchInput
                />
              </mat-form-field>

              <mat-form-field>
                <input
                  matInput
                  name="validatedBy"
                  ngModel
                  placeholder="{{ 'orders.validatedBy' | translate }}"
                  elderSearchInput
                />
              </mat-form-field>
            </div>
          </elder-search-panel>
        </elder-search-box>
      </ng-template>
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 30px"></th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>build</mat-icon>
      </td>
    </ng-container>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">{{ ws.number }}</td>
    </ng-container>

    <!-- name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">{{ ws.name }}</td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">
        <div class="layout-col place-center-start">
          <span class="mat-body-2">{{ ws.description }}</span>
        </div>
      </td>
    </ng-container>

    <!-- facility Column -->
    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.facility' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">{{ ws.company }} / {{ ws.facility }}</td>
    </ng-container>

    <!-- gateway.enabled Column -->
    <ng-container matColumnDef="gateway.enabled">
      <th mat-header-cell *matHeaderCellDef style="width: 100px" mat-sort-header>
        {{ 'gateway.title' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">
        @if (ws?.gateway?.enabled) {
          <mat-icon>usb</mat-icon>
        }
      </td>
    </ng-container>

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.createdAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">
        {{ ws.createdAt | date: 'short' }}
      </td>
    </ng-container>
  </elder-table>
</elder-single-pane-wrapper>
